import React from 'react';

export const TypeStaff = ({ typedName, setTypedName }) => {

    const clearTyped = () => {
        setTypedName('');
    };

    return (
        <div className="signature-upload-draw-box">
            <div className="type-signature-wrapper">
                <input
                    type="text"
                    className="type-signature-input"
                    placeholder="Enter your name"
                    value={typedName}
                    onChange={(e) => setTypedName(e.target.value)}
                />
                <div className="type-signature-preview">
                    <p className="type-signature-text">{typedName}</p>
                    <div className="canvas-line" />
                    <div className="type-signature-actions">
                        <div style={{ width: '25%' }} />
                        <div style={{ width: '50%' }} />
                        <div style={{ width: '25%', textAlign: 'end' }}>
                            {typedName && (
                                <button className="type-signature-clear-btn" onClick={clearTyped}>
                                    Clear
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
